const initialState = { config: { ads: { disabled: true }, paidContent: { closeContentIfCountFails: false } }, showButtonCloseIframe: true };

export default function SettingsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_CONFIG':
      return {
        ...state,
        config: action.config
      };
    case 'SHOW_CLOSE_BUTTON_IFRAME':
      return {
        ...state,
        showButtonCloseIframe: true
      };
    case 'HIDE_CLOSE_BUTTON_IFRAME':
      return {
        ...state,
        showButtonCloseIframe: false
      };
    default:
      return state;
  }
}
